import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { ChatsystemOptionInterface } from '@monsido/core/session/chatsystem-option.interface';
import { chatSystems } from '@monsido/core/constants/general.constant';
import '@client/app/modules/chat/forethought/forethought.types';

declare global {
    interface Window {
        Intercom?: (command: string, ...args: unknown[]) => void;
        Velaro?: { Engagement?: { ToggleInline: () => void } };
        zE?: (widget: string, action: string) => void;
    }
}

interface ChatSystem {
    system: string;
    options?: ChatsystemOptionInterface;
    entire_env?: boolean;
    reseller?: number;
}

@Injectable({
    providedIn: 'root',
})
export class ActiveChatService {
    private activeSystemName: ChatSystem = { system: 'none' };

    constructor (
        private sessionService: SessionService,
    ) {
        this.sessionService.customer$.subscribe((customer) => {
            if (customer) {
                this.activeSystemName = this.computeActiveChat();
            } else {
                this.activeSystemName = { system: 'none' };
            }
        });
    }

    private computeActiveChat (): ChatSystem {
        // Intercom is only used for banners/messages. Default chat comes from config
        // (`chatSystems.default`); without one, no chat is shown.
        const defaultChat = (chatSystems as { default?: ChatSystem }).default;
        let activeSystem: ChatSystem = defaultChat ? { ...defaultChat } : { system: 'none' };

        const selectedServer = this.sessionService.getSelectedServer();
        for (const [key, value] of Object.entries(chatSystems.environments)) {
            if (key === selectedServer) {
                for (const envConfig of value as ChatSystem[]) {
                    if (envConfig.entire_env === true) {
                        activeSystem = envConfig as ChatSystem;
                    } else if (this.sessionService.customer && envConfig.reseller === this.sessionService.customer.reseller.id) {
                        activeSystem = envConfig as ChatSystem;
                    }
                }
            }
        }

        if (activeSystem.system === 'intercom') {
            activeSystem = { system: 'none' };
        }
        return activeSystem;
    }

    getActiveChat (): ChatSystem {
        return this.activeSystemName;
    }

    openChat (): void {
        const system = this.activeSystemName.system;

        if (system === 'forethought' && typeof window.Forethought === 'function') {
            window.Forethought('widget', 'show');
            window.Forethought('widget', 'open');
        } else if (system === 'intercom' && typeof window.Intercom === 'function') {
            window.Intercom('show');
        } else if (system === 'velaro' && window.Velaro?.Engagement) {
            window.Velaro.Engagement.ToggleInline();
        } else if (system === 'zendesk' && typeof window.zE === 'function') {
            window.zE('messenger', 'show');
            window.zE('messenger', 'open');
        }
    }
}
